import ColVisibilitySelector from "components/DataTable/ColVisibilitySelector";
import ItemActionsMenu from "components/DataTable/ItemActionsMenu";
import React from "react";
import Checkbox from "components/Checkbox/Checkbox";
import moment from 'moment';
import Button from "components/Button/Button";
import { getStatusButtonColor } from "helpers/utils";

export default {
    TABLE: {
        className: "data-table-audits",
        initialSortKey: "assigned",
        initialSortOrder: "desc"
    },

    COLUMN: [
        {
            label: "Row Selector",
            key: "row-selector",
            header: ({ customTableProps }) => {
                const isSelectedAll =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.rowsData &&
                    customTableProps.rowsData.length &&
                    customTableProps.selectedRows.length ===
                        customTableProps.rowsData.length
                        ? true
                        : false;
                return (
                    <Checkbox
                        checked={isSelectedAll}
                        onChange={() => customTableProps.doSelectAll()}
                        name="row-selector"
                    />
                );
            },
            className: "col-row-selector",
            format: ({ rowData, customTableProps }) => {
                const isSelected =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.selectedRows.some((checkbox) => {
                        return checkbox.id === rowData.id;
                    })
                        ? true
                        : false;
                return (
                    <Checkbox
                        checked={isSelected}
                        onChange={() => customTableProps.onRowSelect({ rowData })}
                        name="row-selector"
                    />
                );
            },
            canBeHidden: false
        },
        {
            label: "Title",
            header: "TITLE",
            key: "name",
            sortable: true,
            className: "title",
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData["name"]}</span>;
            }
        },
        {
            label: "Regulatory",
            header: "REGULATORY",
            key: "regulatory_act",
            sortable: true,
            className: "type",
            format: ({ rowData }) => {
                return <span>{rowData["regulatory_act"]}</span>;
            }
        },
        {
            label: "Assigned",
            header: "ASSIGNED",
            key: "assigned",
            sortable: true,
            className: "assigned",
            canBeHidden: true,
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData['assigned'] ? moment(rowData['assigned']).format('MM/DD/YYYY') : ''}</span>;
            }
        },
        {
            label: "Launch",
            header: "LAUNCH DATE",
            key: "launch_date",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData }) => {
                return <span>{rowData['launch_date'] ? moment(rowData['launch_date']).format('MM/DD/YYYY') : '-'}</span>;
            }
        },
        {
            label: "Taken",
            header: "TAKEN",
            key: "taken",
            sortable: true,
            className: "taken",
            canBeHidden: true,
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData['taken'] ? moment(rowData['taken']).format('MM/DD/YYYY') : '-'}</span>;
            }
        },
        {
            label: "Audit",
            header: "AUDIT",
            key: "actName",
            sortable: true,
            className: "act",
            canBeHidden: true,
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData["actName"]}</span>;
            }
        },
        {
            label: "Frequency",
            header: "FREQUENCY",
            key: "frequency_label",
            sortable: true,
            className: "frequency",
            canBeHidden: true,
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData.frequency_label}</span>;
            }
        },
        {
            label: "Site",
            header: "SITE",
            key: "siteName",
            sortable: true,
            className: "site",
            format: ({ rowData, customTableProps }) => {
                // return <span>{rowData.siteName}</span>;
                return <span>{rowData.siteName == null ? 'All Sites' : rowData.siteName}</span>;
            }
        },
        {
            label: "Status",
            header: "STATUS",
            key: "status",
            sortable: true,
            className: "status",
            canBeHidden: true,
            format: ({ rowData, customTableProps }) => {
                const status = rowData.configuration && rowData.configuration.status_label;
                const color = getStatusButtonColor(status, ["Finalized"], ["Error on launch", "Error on reset", "Closed incomplete"]);
                return <span><Button cursorDefault={customTableProps.cursorDefault} color={color} size="md" text={status} onClick={() => null} /></span>;
            }
        },
        {
            label: "Actions",
            key: "actions",
            format: ({ rowData, customTableProps }) => {
                const actionMenuDropDown = React.createRef();
                return (
                    <ItemActionsMenu
                        ref={actionMenuDropDown}
                        actions={(() => {
                            return [
                                {
                                    label: "View",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.view(rowData);
                                    }
                                },
                                rowData.act !== "6" && {
                                    label: "Edit",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.edit(rowData);
                                    }
                                },
                                customTableProps.download && rowData.act !== "6" && {
                                    label: "Download",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.download(rowData);
                                    }
                                },
                                customTableProps.upload && rowData.act !== "6" && {
                                    label: "Upload",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.upload(rowData);
                                    }
                                },
                                {
                                    label: "Delete",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.delete(rowData);
                                    }
                                },
                                (rowData.finalized === 't' && customTableProps.is_super) ? {
                                    label: "Reopen",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.reopen(rowData);
                                    }
                                } : null
                            ];
                        })()}
                    />
                );
            },
            className: "col-actions",
            header: ({ customTableProps }) => {
                return (
                    <ColVisibilitySelector
                        colDefs={customTableProps.colDefs}
                        visibleColumnKeys={customTableProps.visibleColumnKeys}
                        onChangeVisibility={colKey =>
                            customTableProps.onChangeVisibility(colKey)
                        }
                    />
                );
            }
        }
    ]
};
